module.exports = {
appStyle: (theme) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        backgroundColor: theme.primary,
        transition: '1s',
        color: theme.font.regular,
        overflowY: 'hidden'
      }
},

gradientText: (textSize,margin) => {
  return {
    fontSize: textSize ? textSize: '2.5em',
    textAlign: 'center', 
    margin: margin ? margin : 0, 
    padding: 0,
    background: '-webkit-linear-gradient(-45deg,#dedede,#333)',
    backgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    WebkitBackgroundClip: 'text',
    }
},

backgroundWrapper: (theme) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100vw',
    backgroundColor: theme.secondary,
    margin: 0,
    padding: 0,
    textAlign: 'center'
    }
},

cardStyle: (theme) => {
  return {
    width: '120px',
    margin: '10px',
    flexShrink: 0,
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: theme.secondary,
    border: `1px ${theme.main}20 solid`,
    padding: '10px'
}
},
generalButtonStyle: (theme) => {
  return {
    backgroundColor: theme.secondary, 
    color: theme.font.regular, 
    border: 'none', 
    width: 100,
    height: 30,
    border: `1px solid ${theme.font.regular}50`,
    borderRadius: '5px',
    gap: 5,
    margin: '10px'
}
}
}
